import { ACTION } from "./constants";
import request from "../../../../utils/request";
import { requestConfig } from "../../../../config/apiResource";
import { showMainLoader, hideMainLoader } from "../../../actions";
import { formDataGenerator, checkIframeContent } from "../../../../utils/common";

export function getAllFundProducts(serverData, formData) {
  let formDataValue,
    data = {
      fund_type: "",
      categories: "",
      risk_profile: "",
      limit: 6,
      offset: 0,
      period: 'Since Inception',
      sort: 'Popularity',
      plan_type: checkIframeContent() ? 'direct':'indirect'
    };
  if (!__CLIENT__) {
    let queryParams;
    let goal_based = [
      "wealth-creation",
      "tax-savings",
      "children-fund",
      "retirement-planning",
      "regular-income",
    ];
    let path = serverData.queryString.split("/product-solutions/");
    if (path[1] && goal_based.includes(path[1])) {
      queryParams = {
        fund_type: path[1].replace(/-/g, " ") || "",
      };
    } else if (path[1] != "investment-basket" && path[1] != "nfo") {
      let catgr = path[1] ? path[1].replace(/-/g, " ") : "";
      queryParams = {
        category: catgr,
      };
    }
    data["fund_type"] = queryParams.fund_type ? queryParams.fund_type : "";
    data["categories"] = queryParams.category ? queryParams.category : "";
    formData = formDataGenerator(data);
    formDataValue = formData;
  } else {
    formDataValue = formData;
  }
  return (dispatch) => {
    // dispatch(showMainLoader());

    return request(requestConfig.getAllFundProducts(formDataValue))
      .then((json) => {
        // dispatch(hideMainLoader());

        json &&
          dispatch({
            type: ACTION.GET_ALL_FUNDS_PRODUCT_LIST,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        // dispatch(hideMainLoader());

        console.log("Got Error with about us media video data: " + error);
      });
  };
}
export function getClearAllFundProducts() {
  return dispatch => {
      dispatch({ type: ACTION.GET_ALL_FUNDS_PRODUCT_LIST , data: [] })
  }
}
export function getAllFundProductsFilters() {
  return (dispatch) => {
    return request(requestConfig.getAllFundProductsFilters())
      .then((json) => {
        json &&
          dispatch({
            type: ACTION.GET_ALL_FUNDS_PRODUCT_FILTERS,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about us media video data: " + error);
      });
  };
}

export function getSingleFundDetails(serverData, data, typeData) {
  let formDataValue, typeDataValue;
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    typeDataValue = urlArray[urlArray.length - 2];

    let fundType = "";
    if (urlArray[urlArray.length - 1] == "direct") {
      fundType = "direct";
    } else if (urlArray[urlArray.length - 1] == "regular"){
      fundType = "indirect";
    }else {
      fundType = urlArray[urlArray.length - 1];
    }
    let formData = {
      plan_type: fundType,
    };
    formDataValue = formDataGenerator(formData);
  } else {
    formDataValue = data;
    typeDataValue = typeData;
  }

  return async dispatch => {
    try {
      const json = await request(requestConfig.getSingleFundDetails(formDataValue, typeDataValue));
      if (json && json.code === 404) {
        serverData && serverData.response && serverData.response.status(404);
      }
      if (json && json.data) {
        dispatch({ type: ACTION.GET_SINGLE_FUND_DETAILS, data: json.data });
      }
      return json;
    } catch (error) {
      console.log("Got Error with about us media video data: " + error);
    }
  };
}
export function getSingleFundNav(formData, type) {
  return (dispatch) => {
    return request(requestConfig.getSingleFundNav(formData, type))
      .then((json) => {
        json && dispatch({ type: ACTION.GET_SINGLE_FUND_NAV, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about us media video data: " + error);
      });
  };
}

export function getNfoList() {
  return (dispatch) => {
    return request(requestConfig.getNfoList())
      .then((json) => {
        json && dispatch({ type: ACTION.GET_NFO_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about us media video data: " + error);
      });
  };
}
export function postCompareList(formData) {
  return (dispatch) => {
    return request(requestConfig.postCompareList(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.POST_COMPARE_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about us media video data: " + error);
      });
  };
}

export function postCompareListDublicate(formData) {
  return (dispatch) => {
    return request(requestConfig.postCompareListDublicate(formData))
      .then((json) => {
        json &&
          dispatch({
            type: ACTION.POST_COMPARE_LIST_DUBLICATE,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about us media video data: " + error);
      });
  };
}

export function postCompareFunds(formData) {
  return (dispatch) => {
    return request(requestConfig.postCompareFunds(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.POST_COMPARE_FUNDS, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about us media video data: " + error);
      });
  };
}

export function postNavOverview(formData, typeData) {
  return (dispatch) => {
    return request(requestConfig.postNavOverview(formData, typeData))
      .then((json) => {
        json && dispatch({ type: ACTION.POST_NAV_OVERVIEW, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about us media video data: " + error);
      });
  };
}
// etf
export function postSmallCase(ticker, authTokenflagid) {
  return (dispatch) => {
    return request(requestConfig.postSmallCase(ticker, authTokenflagid))
      .then((json) => {
        json && dispatch({ type: "POST_SMALL_CASE", data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with subscribe product data: " + error);
      });
  };
}
export function postInvestDataETF(data) {
  return (dispatch) => {
    return request(requestConfig.postInvestDataETF(data))
      .then((json) => {
        json && dispatch({ type: "POST_INVEST_ETF", data: json.data });
      })
      .catch((error) => {
        console.log("Got Error with subscribe POST_INVEST_ETF data: " + error);
      });
  };
}

export function postSmallCaseID(data) {
  return (dispatch) => {
    return request(requestConfig.postSmallCaseID(data))
      .then((json) => {
        json && dispatch({ type: "POST_INVEST_ETF", data: json.data });
      })
      .catch((error) => {
        console.log("Got Error with subscribe POST_INVEST_ETF data: " + error);
      });
  };
}

export const clearSubscribeResult = () => {
  return {
    type: ACTION.CLEAR_SUBSCRIBE_RESULT,
  };
};
//etf apis
export function getEtf() {
  return (dispatch) => {
    return request(requestConfig.getEtf())
      .then((json) => {
        json && dispatch({ type: ACTION.GET_ETF, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about us media video data: " + error);
      });
  };
}
export function getEtfListOfFunds(formData, type) {
  return (dispatch) => {
    return request(requestConfig.getEtfListOfFunds(formData, type))
      .then((json) => {
        json && dispatch({ type: ACTION.GET_ETF_FUNDS, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about us media video data: " + error);
      });
  };
}

export function getEtfFundList(formData) {
  return (dispatch) => {
    return request(requestConfig.getEtfFundList(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.GET_ETF_FUNDS_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about us media video data: " + error);
      });
  };
}

export function postEtfSubscribe(formData) {
  return (dispatch) => {
    return request(requestConfig.postEtfSubscribe(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.POST_ETF_SUBSCRIBE, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about us media video data: " + error);
      });
  };
}
export function getSchemeContentNode(nodeTitle) {
  return (dispatch) => {
    // dispatch(showMainLoader());
    return request(requestConfig.getSchemeContentNode(nodeTitle))
      .then((json) => {
        // dispatch(hideMainLoader());
        json &&
          dispatch({ type: ACTION.GET_SCHEME_CONTENT_SCHEME, data: json.data });
        return json;
      })
      .catch((error) => {
        // dispatch(hideMainLoader());
        console.log("Got Error with Scheme data: " + error);
      });
  };
}
export function subscribeProduct(lang, formData, isProduct) {
  return (dispatch) => {
    return request(requestConfig.subscribeProduct(lang, formData, isProduct))
      .then((json) => {
        json &&
          dispatch({ type: ACTION.POST_SUBSCRIBE_PRODUCT, data: json.data });
      })
      .catch((error) => {
        console.log("Got Error with subscribe product data: " + error);
      });
  };
}
export function getNfoOverview(serverData,formData,type) {
  let typeDataValue, formDataValue;
  if(serverData.url){
      let urlArray=serverData.url.split('/');
      typeDataValue = urlArray[urlArray.length-2];

      let nfoPlan = urlArray[urlArray.length-1], formPlan;
      if (nfoPlan === "direct") {
          formPlan = "direct";
      } else {
          formPlan = "indirect";
      }
      let dataValue = {
          plan_type:formPlan
      }
      formDataValue = formDataGenerator(dataValue)
  }else{
      typeDataValue = type;
      formDataValue = formData;
  }
  return (dispatch) => {
    return request(requestConfig.getNfoOverview(formDataValue,typeDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.GET_NFO_OVERVIEW, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with nfo overview: " + error);
      });
  };
}
// investment basket api
export function getGoals() {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getGoals())
      .then((json) => {
        dispatch(hideMainLoader());
        json && dispatch({ type: ACTION.GET_GOALS_CONTENT, data: json.data });

        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with Learn data: " + error);
      });
  };
}
export function getGoalQuestions(goalId) {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getGoalQuestions(goalId))
      .then((json) => {
        dispatch(hideMainLoader());
        json && dispatch({ type: ACTION.GET_GOAL_QUESTION, data: json });

        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with Learn data: " + error);
      });
  };
}
export function getGoalSuggestions(params) {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getGoalSuggestions(params))
      .then((json) => {
        dispatch(hideMainLoader());
        json && dispatch({ type: ACTION.GET_GOAL_SUGGESTION, data: json });

        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with Learn data: " + error);
      });
  };
}

export function verifyPAN() {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.verifyPAN())
      .then((json) => {
        dispatch(hideMainLoader());
        json && dispatch({ type: ACTION.VERIFY_PAN, data: json });

        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with Learn data: " + error);
      });
  };
}

export function verifyKYC(params) {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.verifyKYC(params))
      .then((response) => {
        dispatch(hideMainLoader());
        response &&
          dispatch({
            type: ACTION.VERIFY_KYC,
            data: JSON.parse(decryptAES(response)),
          });
        return JSON.parse(decryptAES(response));
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with Verify KYC data: " + error);
      });
  };
}
export function forceLogout(params) {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.forceLogout(params))
      .then((response) => {
        dispatch(hideMainLoader());
        response &&
          dispatch({
            type: ACTION.FORCE_LOGOUT,
            data: JSON.parse(decryptAES(response)),
          });
        return JSON.parse(decryptAES(response));
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with Verify KYC data: " + error);
      });
  };
}
export function savePreLoginData(params, uuid) {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.savePreLoginData(params, uuid))
      .then((response) => {
        dispatch(hideMainLoader());
        response &&
          dispatch({
            type: ACTION.SAVE_PRE_LOGIN_DATA,
            data: JSON.parse(decryptAES(response)),
          });
        return JSON.parse(decryptAES(response));
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with save prelogin data: " + error);
      });
  };
}
export function validateBasketSchemes(params) {
  return dispatch => {
      dispatch(showMainLoader());
      return request(requestConfig.validateBasketSchemes(params))
          .then((response) => {
              dispatch(hideMainLoader());
              response && dispatch({ type: ACTION.VALIDATE_BASKET_SCHEMES, data: JSON.parse(decryptAES(response)) });
              return JSON.parse(decryptAES(response));
          }).catch((error) => {
              dispatch(hideMainLoader());
              console.log("Got Error with validate basket data: " + error)
          });
  }
}

export function verifyOTP(params) {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.verifyOTPJava(params))
      .then((response) => {
        dispatch(hideMainLoader());
        response &&
          dispatch({
            type: ACTION.VERIFY_OTP,
            data: JSON.parse(decryptAES(response)),
          });
        return JSON.parse(decryptAES(response));
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with Verify OTP data: " + error);
      });
  };
}

export function resendOTP(params) {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.resendOTPJava(params))
      .then((response) => {
        dispatch(hideMainLoader());
        response &&
          dispatch({
            type: ACTION.RESEND_OTP,
            data: JSON.parse(decryptAES(response)),
          });
        return JSON.parse(decryptAES(response));
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with Resend OTP data: " + error);
      });
  };
}

export function getAllBaskets() {
  return (dispatch) => {
    // dispatch(showMainLoader());
    return request(requestConfig.getAllBaskets())
      .then((json) => {
        // dispatch(hideMainLoader());
        json && dispatch({ type: ACTION.GET_ALL_BASKETS, data: json });

        return json;
      })
      .catch((error) => {
        // dispatch(hideMainLoader());
        console.log("Got Error with Learn data: " + error);
      });
  };
}

export function cleanGoalsContent() {
  return { type: ACTION.CLEAN_GOALS_CONTENT };
}

export function cleanAuthContent() {
  return { type: ACTION.CLEAN_AUTH_CONTENT };
}

export function cleanGoalsQuestion() {
  return { type: ACTION.CLEAN_GOALS_QUESTIONS };
}

export function getRiskQuestionAns() {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getRiskQuestionAns())
      .then((json) => {
        dispatch(hideMainLoader());
        json && dispatch({ type: ACTION.GET_RISK_QUESTION_ANS, data: json });

        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with Learn data: " + error);
      });
  };
}

export function evaluateRiskAppetite(params) {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.evaluateRiskAppetite(params))
      .then((json) => {
        dispatch(hideMainLoader());
        json && dispatch({ type: ACTION.EVALUATE_RISK_APPETITE, data: json });

        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with Learn data: " + error);
      });
  };
}

export function getBasketRecommendation(params) {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getBasketRecommendation(params))
      .then((json) => {
        dispatch(hideMainLoader());
        json &&
          dispatch({ type: ACTION.GET_BASKET_RECOMMENDATION, data: json });

        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with Learn data: " + error);
      });
  };
}

export function getRiskAppetitesList() {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.getRiskAppetitesList())
      .then((json) => {
        dispatch(hideMainLoader());
        json && dispatch({ type: ACTION.GET_RISK_APPETITES_LIST, data: json });

        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with Learn data: " + error);
      });
  };
}

export function cleanRiskContent() {
  return { type: ACTION.CLEAN_RISK_CONTENT };
}

const encryptRSA = (data) => {
  /*Encrypt*/
  let crypt = new JSEncrypt();
  crypt.setKey(ACTION.PASS_PUB_KEY);
  // Encrypt the data with the public key.
  return crypt.encrypt(data);
};

const decrypttRSA = (data) => {
  /*Encrypt*/
  let crypt = new JSEncrypt();
  crypt.setKey(ACTION.PRIV_KEY);
  // Encrypt the data with the public key.
  return crypt.decrypt(data);
};

const decryptAES = (encryptedData) => {
  let crypt = new JSEncrypt();
  crypt.setKey(ACTION.PRIV_KEY);
  let header = encryptedData.substring(0, encryptedData.lastIndexOf("|"));
  let data = CryptoJS.enc.Base64.parse(
    encryptedData.substring(
      encryptedData.lastIndexOf("|") + 1,
      encryptedData.length
    )
  );
  let responseData = readAesResponsePayload(crypt.decrypt(header), data);
  return responseData;
  // response.data = angular.fromJson(responseData);
};

const readAesResponsePayload = (header, data) => {
  let iv = CryptoJS.enc.Base64.parse(
    header.substring(0, header.lastIndexOf("|"))
  );
  let key = CryptoJS.enc.Base64.parse(
    header.substring(header.lastIndexOf("|") + 1, header.length)
  );
  let decryptJson = CryptoJS.AES.decrypt(
    {
      ciphertext: data,
    },
    key,
    { iv: iv }
  );
  return decryptJson.toString(CryptoJS.enc.Utf8);
};

function encryptAES(data) {
  let crypt = new JSEncrypt();
  crypt.setKey(ACTION.PASS_PUB_KEY);
  let key = CryptoJS.lib.WordArray.random(128 / 8); //16bit
  let IV = CryptoJS.lib.WordArray.random(128 / 8); //8bit
  let aesEncrypted = CryptoJS.AES.encrypt(data, key, { iv: IV });
  let ivAndKey =
    CryptoJS.enc.Base64.stringify(IV) +
    "|" +
    CryptoJS.enc.Base64.stringify(key);
  return (
    crypt.encrypt(ivAndKey) +
    "|" +
    CryptoJS.enc.Base64.stringify(aesEncrypted.ciphertext)
  );
}

function encryptAESforKYC(data) {
  let cypherText = CryptoJS.AES.encrypt(JSON.stringify(data), "tgkpdi45sd");
  return cypherText.toString();
}
export function allSectionsMeta(serverData, type) {
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    type = urlArray[urlArray.length - 1];
  }
  return (dispatch) => {
    return request(requestConfig.allSectionsMeta(type))
      .then((json) => {
        json && dispatch({ type: ACTION.BASKET_META, data: json });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with verify pan folio data: " + error);
      });
  };
}
export function productIndexList() {
  return (dispatch) => {
    dispatch(showMainLoader());
    return request(requestConfig.productIndexList())
      .then((json) => {
        dispatch(hideMainLoader());
        json && dispatch({ type: ACTION.GET_INDEX_FUND_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        dispatch(hideMainLoader());
        console.log("Got Error with Learn data: " + error);
      });
  };
}
export function indexSubscribe(formData) {
  return (dispatch) => {
    return request(requestConfig.indexSubscribe(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.INDEX_SUBSCRIBE, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with about us media video data: " + error);
      });
  };
}
export function smallCaseTokenHide() {
  return (dispatch) => {
    return request(requestConfig.smallCaseTokenHide())
      .then((json) => {
        json &&
          dispatch({ type: ACTION.SMALL_CASE_TOKEN_HIDE, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Learn data: " + error);
      });
  };
}
export function cleanIndexFundApi() {
  return { type: ACTION.CLEAN_INDEX_FUND_CONTENT };
}

export {
  encryptAES,
  readAesResponsePayload,
  decryptAES,
  decrypttRSA,
  encryptRSA,
  encryptAESforKYC,
};

export function getSingleFundDetailsPromotion(serverData,data,typeData) {
  let formDataValue, typeDataValue;
  if(serverData.url){
      typeDataValue = 'hdfc-flexi-cap-fund';

      let fundType = 'indirect';
      
      let formData = {
          plan_type: fundType,
      }
      formDataValue = formDataGenerator(formData);
  }else{
      formDataValue = data;
      typeDataValue = typeData;
  }
  
  return dispatch => {
      return request(requestConfig.getSingleFundDetails(formDataValue,typeDataValue))
          .then((json) => {
              json && dispatch({ type: ACTION.GET_SINGLE_FUND_DETAILS , data: json.data });
              return json;
          }).catch((error) => {
              console.log("Got Error with flexi cap promotion data: " + error)
          });
  }
}
export function getSingleFundDetailsquicklink(serverData,data,typeData) {
  let formDataValue, typeDataValue;
  if(serverData.url){
      typeDataValue = 'hdfc-flexi-cap-fund';

      let fundType = 'direct';
      
      let formData = {
          plan_type: fundType,
      }
      formDataValue = formDataGenerator(formData);
  }else{
      formDataValue = data;
      typeDataValue = typeData;
  }
  
  return dispatch => {
      return request(requestConfig.getSingleFundDetails(formDataValue,typeDataValue))
          .then((json) => {
              json && dispatch({ type: ACTION.GET_SINGLE_FUND_DETAILS , data: json.data });
              return json;
          }).catch((error) => {
              console.log("Got Error with flexi cap promotion data: " + error)
          });
  }
}
export function postLinegraph(formData, typeData) {
  return dispatch => {
      dispatch(showMainLoader());
      return request(requestConfig.postLinegraph(formData, typeData))
          .then((json) => {
              json && dispatch({ type: ACTION.POST_LINE_GRAPH , data: json.data });
              dispatch(hideMainLoader());
              return json;
          }).catch((error) => {
              dispatch(hideMainLoader());
              console.log("Got Error Line Graph Data: " + error)
          });
  }
}
export const clearPostNavOverview = () => {
  return dispatch => {
      dispatch({ type: ACTION.POST_NAV_OVERVIEW , data: [] })
  }
}